module.exports = __webpack_public_path__ + "img/wardrobe.5a50c82f.svg";